<div class="employee-contact-card-container" *ngIf="employeeContactCard$ | withLoading | async as employeeContactCard">
    <ng-template [ngIf]="employeeContactCard.value">
        <div class="employee-details" role="region" [attr.aria-label]="(employeeContactCard.value.firstname && employeeContactCard.value.lastname) ? (employeeContactCard.value.firstname + ' ' + employeeContactCard.value.lastname) : 'Employee contact card'">
            <div class="profile-pic-container">
                <app-employee-image class="profile-pic" mat-card-image role="img" [profilePhoto]="employeeContactCard.value?.profilePhoto" round="true" width="200" height="200" [attr.aria-label]="(employeeContactCard.value.firstname && employeeContactCard.value.lastname) ? (employeeContactCard.value.firstname + ' ' + employeeContactCard.value.lastname + ' profile photo') : 'Employee profile photo'"></app-employee-image>
            </div>
            <div class="details">
                <div class="name-details"
                     role="group"
                     tabindex="0"
                     [attr.aria-label]="'Name details for ' + (employeeContactCard.value.firstname || '') + ' ' + (employeeContactCard.value.lastname || '')">
                    <h1 class="name" *ngIf="employeeContactCard.value.firstname && employeeContactCard.value.lastname" aria-label="Name: {{employeeContactCard.value.firstname}} {{employeeContactCard.value.lastname}}">{{employeeContactCard.value.firstname}} {{employeeContactCard.value.lastname}}</h1>
                    <div class="username" *ngIf="employeeContactCard.value.preferredName" aria-label="Preferred name: {{employeeContactCard.value.preferredName}}">{{employeeContactCard.value.preferredName}}</div>
                    <div class="username" *ngIf="employeeContactCard.value.customClientId" aria-label="Employee ID: {{employeeContactCard.value.customClientId}}">{{employeeContactCard.value.customClientId}}</div>
                    <!-- <div class="username" *ngIf="employeeContactCard.value.organization">{{employeeContactCard.value.organization.name}}</div> -->
                    <div role="group" aria-label="Employee status">
                        <span 
                            *ngIf="employeeContactCard.value.subStatus"
                            class="green-chip mat-chip mat-standard-chip"
                        >
                            {{employeeContactCard.value.subStatus?.text}}
                        </span>
                    </div>
                </div>

                <div class="other-details" role="list">
                    <div class="phone" role="listitem" tabindex="0" *ngIf="employeeContactCard.value.userId" aria-label="User ID: {{employeeContactCard.value.userId}}">
                        {{employeeContactCard.value.userId}}
                    </div>
                    <div class="phone" role="listitem" tabindex="0" *ngIf="employeeContactCard.value.workPhone" aria-label="Work phone: {{employeeContactCard.value.phoneNumber}}">
                        <mat-icon class="material-icons-outlined" aria-hidden="true">call</mat-icon>
                        {{employeeContactCard.value.phoneNumber}}
                    </div>
                    <div class="phone" role="listitem" tabindex="0" *ngIf="employeeContactCard.value.email" aria-label="Email: {{employeeContactCard.value.email}}">
                        <mat-icon class="material-icons-outlined" aria-hidden="true">contact_mail</mat-icon>
                        {{employeeContactCard.value.email}}
                    </div>
                    <div role="listitem" *ngIf="employeeContactCard.value.positions?.length > 0">
                        <div class="title" role="list">
                            <ng-container *ngFor="let position of employeeContactCard.value.positions">
                                <div role="listitem" tabindex="0" [attr.aria-label]="'Position: ' + position.name + (getLocation(employeeContactCard.value.workLocations, position) != null ? ', Location: ' + getLocation(employeeContactCard.value.workLocations, position) : '')">
                                    <mat-icon class="material-icons-outlined" aria-hidden="true">account_balance</mat-icon>
                                    {{position.name}}
                                    <ng-container *ngIf="getLocation(employeeContactCard.value.workLocations, position)!= null">
                                        <br>
                                        <span class="k-ml-4">{{getLocation(employeeContactCard.value.workLocations, position)}}</span>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="manager-details" *ngIf="employeeContactCard.value.managers?.length > 0" role="region" aria-label="Reports To">
                    <div 
                        class="primaryColor label" 
                        setColor="primaryColour" 
                        appLocalizationPopupDirective 
                        [localizationCode]="'ReportsTo'"
                        aria-hidden="true"
                    >{{ 'ReportsTo' | translate: {Default: "Reports To"} }}</div>
                    <ng-container *ngFor="let manager of employeeContactCard.value.managers">
                        <div 
                        setColor 
                        [setColorRules]="[
                            {
                                color: 'primaryColour',
                                events: ['hover']
                            }
                        ]" 
                        class="manager-name primaryHoverColor" 
                        routerLink="{{routes.TALENT_TRACK}}{{routes.EDIT}}/{{manager.id}}{{routes.EMPLOYEE_DETAILS}}"
                        [attr.aria-label]="'Reports to: ' + manager.firstName + ' ' + manager.lastName">
                            <app-employee-image class="profile-pic" [profilePhoto]="manager.profilePhoto" aria-hidden="true"></app-employee-image>

                            <span class="name">
                                {{manager.firstName}} {{manager.lastName}}
                            </span>
                        </div>
                    </ng-container>
                </div>

                <mat-accordion>
                    <mat-expansion-panel class="mat-elevation-z0" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                      <mat-expansion-panel-header>
                        <mat-panel-title appLocalizationPopupDirective [localizationCode]="'MoreDetails'">
                            {{ 'MoreDetails' | translate: {Default: "More Details"} }}
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <mat-list>
                
                        <mat-list-item *ngIf="employeeContactCard.value.status" appLocalizationPopupDirective [localizationCode]="'Status'">{{ 'Status' | translate: {Default: "Status"} }}: {{employeeContactCard.value.status}} </mat-list-item>
                        <mat-list-item *ngIf="employeeContactCard.value.organization" appLocalizationPopupDirective [localizationCode]="'Organization'">{{ 'Organization' | translate: {Default: "Organization"} }}: {{employeeContactCard.value.organization?.name}} </mat-list-item>
                        <mat-list-item *ngIf="employeeContactCard.value.timezone"> {{employeeContactCard.value.timezone?.text}} </mat-list-item>
                        <a *ngIf="employeeContactCard.value.facebookUrl" target="_blank" [href]="employeeContactCard.value.facebookUrl" aria-label="Facebook profile (opens in new tab)" rel="noopener noreferrer">
                            <mat-list-item class="navigation-link">
                                <img class="ms-icon" src="assets/icons/facebook-icon.svg" alt="" aria-hidden="true" style="width: 30px;
                                    margin-right: 10px;
                                    vertical-align: middle;"> {{employeeContactCard.value.facebookUrl}} 
                            </mat-list-item>
                        </a>
                        <a *ngIf="employeeContactCard.value.linkedInUrl" target="_blank" [href]="employeeContactCard.value.linkedInUrl" aria-label="LinkedIn profile (opens in new tab)" rel="noopener noreferrer">
                            <mat-list-item class="navigation-link">
                                <img class="ms-icon" src="assets/icons/linkedin-icon.svg" alt="" aria-hidden="true" style="width: 30px;
                                    margin-right: 10px;
                                    vertical-align: middle;"> {{employeeContactCard.value.linkedInUrl}} 
                            </mat-list-item>
                        </a>
                        <a *ngIf="employeeContactCard.value.linkedInUrl" target="_blank" [href]="employeeContactCard.value.linkedInUrl" aria-label="Twitter profile (opens in new tab)" rel="noopener noreferrer">
                            <mat-list-item *ngIf="employeeContactCard.value.twitterHandle">
                                <img class="ms-icon" src="assets/icons/twitter-icon.svg" alt="" aria-hidden="true" style="width: 30px;
                                    margin-right: 10px;
                                    vertical-align: middle;"> {{employeeContactCard.value.twitterHandle}} 
                            </mat-list-item>
                        </a>
                        
                       </mat-list>

                        <ng-container *appHasModuleAccess="modules.TIME_OFF">
                            <ng-container *appHasFeature="features.TIME_OFF">
                                <app-employee-schedule *ngIf="panelOpenState === true" [employeeId]="employeeId"></app-employee-schedule>
                            </ng-container>
                        </ng-container>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
    </ng-template>
    <ng-template [ngIf]="employeeContactCard.error">
      <p role="alert">There was an error loading</p>
    </ng-template>
    <ng-template [ngIf]="employeeContactCard.loading">
        <div class="employee-details" role="status" aria-label="Loading employee contact card" aria-busy="true">
            <div class="profile-pic-container">
                <ngx-skeleton-loader 
                count="1" 
                appearance="circle"
                [theme]="{ 
                    'height.px': 200,
                    'width.px': 200
                }">
                </ngx-skeleton-loader>
            </div>
            <div style="width:200px; padding: 10px;">
                <ngx-skeleton-loader
                count="3"
                [theme]="{ 
                    'height.px': 50
                }"
                ></ngx-skeleton-loader>
            </div>
        </div>
    </ng-template>
</div>
